export const LLM_MODEL_DEFAULT_VARIANT = 'default';
